const LOCAL_API = process.env.REACT_APP_LOCAL_API;
const API_TOKEN = process.env.REACT_APP_LOCAL_API_TOKEN;

const getCategories = async () => {
  try {
    const response = await fetch(`${LOCAL_API}/api/get_category_view/`, {
      method: "GET",
      headers: {
        Authorization: `token ${API_TOKEN}`,
      },
    });

    if (!response.ok) {
      console.error(`Fetch error: ${response.status} - ${response.statusText}`);
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching in getCategories:", error);
    throw error;
  }
};

const deleteCategory = async (categoryId) => {
  const API_URL = `${LOCAL_API}/api/delete_category/`;

  const formData = new FormData();
  formData.append("category_id", categoryId);

  try {
    const response = await fetch(API_URL, {
      method: "DELETE",
      headers: {
        Authorization: `token ${API_TOKEN}`,
        Token:
          "cDp3E70JS6-5LHleRiTzvs:APA91bHjc2TIu71l6eIA9a-R6mGSpdiorXheaZIRx6uG-3NJaa_dOwlFtNbOqhyEyePytTmu0yDfnxNaSWE6p4H4A7D_gCRKlFeCylAy__orC1l3iiFhPS6Ze9UjzawvKFcJSk9opG9f",
      },
      body: formData,
    });

    if (!response.ok) {
      console.error(
        `Delete Error: ${response.status} - ${response.statusText}`,
      );
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.text();
    return data;
  } catch (error) {
    console.error("Error in deleteCategory:", error);
    throw error;
  }
};

const updateCategory = async (payload) => {
  const API_URL = `${LOCAL_API}/api/update_categories_order/`;
  try {
    const response = await fetch(`${API_URL}`, {
      method: "PUT",

      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${API_TOKEN}`,
        Token:
          "cDp3E70JS6-5LHleRiTzvs:APA91bHjc2TIu71l6eIA9a-R6mGSpdiorXheaZIRx6uG-3NJaa_dOwlFtNbOqhyEyePytTmu0yDfnxNaSWE6p4H4A7D_gCRKlFeCylAy__orC1l3iiFhPS6Ze9UjzawvKFcJSk9opG9f",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      console.error(
        `Update Error: ${response.status} - ${response.statusText}`,
      );
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    const data = await response.text();
    return data;
  } catch (error) {
    throw error;
  }
};

const addNewCategory = async (payload) => {
  const API_URL = `${LOCAL_API}/api/add_category/`;

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        Authorization: `token ${API_TOKEN}`,
        "Content-Type": "application/json",
        Token:
          "cDp3E70JS6-5LHleRiTzvs:APA91bHjc2TIu71l6eIA9a-R6mGSpdiorXheaZIRx6uG-3NJaa_dOwlFtNbOqhyEyePytTmu0yDfnxNaSWE6p4H4A7D_gCRKlFeCylAy__orC1l3iiFhPS6Ze9UjzawvKFcJSk9opG9f",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      console.error(
        `Add Category Error: ${response.status} - ${response.statusText}`,
      );
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding category:", error);
    throw error;
  }
};

export { getCategories, deleteCategory, updateCategory, addNewCategory };
